<template>
  <div class="app-container">
    <!-- 顶部导航栏 -->
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="简易版" :name="3"></el-tab-pane>
        <el-tab-pane label="个税" :name="1"></el-tab-pane>
        <el-tab-pane label="税局" :name="2"></el-tab-pane>

      </el-tabs>
    </div>

    <!-- 筛选 -->
    <div class="top_btns clearfix">
      <div class="left_search fl">
        <el-input placeholder="请输入昵称" v-model="listQuery.cnName" style="width: 200px;margin-right:10px" size="small" />
        <el-button class="filter-item" type="primary" @click="getList" size="small" plain>搜索</el-button>
      </div>
      <div class="right_btns fr">
        <el-button @click="handleCreate()" type="primary" size="small">新增</el-button>
      </div>
    </div>

    <!-- table -->
    <el-table :height="contentStyleObj" :data="list" border fit highlight-current-row style="width: 100%;" @selection-change="handleSelectionChange" @sort-change="sortChange" v-loading="loading">
      <template #empty>
        <el-empty :image-size="150" description="没有数据"></el-empty>
      </template>
      <el-table-column label="序号" align="center" width="55" type="index">
      </el-table-column>

      <el-table-column label="昵称" align="center" width="180">
        <template #default="scope">
          <span>{{scope.row.cnName}}</span>
        </template>
      </el-table-column>

      <el-table-column label="学校名称" align="center" width="180">
        <template #default="scope">
          <span>{{scope.row.orgName}}</span>
        </template>
      </el-table-column>

      <el-table-column label="用户名" align="center" width="180">
        <template #default="scope">
          <span>{{scope.row.userName}}</span>
        </template>
      </el-table-column>

      <el-table-column label="密码" align="center" width="180">
        <template #default="scope">
          <span>{{scope.row.password}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" min-width="380" class-name="small-padding fixed-width">
        <template #default="scope">
            <el-button type="primary" size="small" @click="handleUpdate(scope.row)" plain>编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row)" plain>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <qzf-pagination v-show="total>0" :total="total" v-model:page="listQuery.page" v-model:limit="listQuery.limit" @pagination="getList" />
    </div>

<!-- 新增编辑的弹窗 -->
    <el-dialog :close-on-click-modal="false" destroy-on-close :title="textMap[dialogStatus]" v-model="dialogFormVisible"  class="button_bg" width="700px">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="140px" >
        <div class="grid-content bg-purple">
          <el-form-item label="昵称:" prop="cnName" size="small">
            <el-input v-model="temp.cnName" style="width:70%"/>
          </el-form-item>
          <el-form-item label="用户名:" prop="userName" size="small">
            <el-input v-model="temp.userName" style="width:70%"/>
          </el-form-item>

          <el-form-item label="密码:" prop="password" size="small">
            <el-input v-model="temp.password" style="width:70%"/>
          </el-form-item>

          <el-form-item label="学校名称:" prop="orgName" size="small">
            <el-input v-model="temp.orgName" style="width:70%"/>
          </el-form-item>

          <el-form-item label="系统类型:" prop="sys">
            <el-radio-group v-model="temp.sys" disabled>
              <el-radio :label="2">税局</el-radio>
              <el-radio :label="1">个税</el-radio>
              <el-radio :label="3">简易版</el-radio>
            </el-radio-group>
          </el-form-item>

        </div>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()" size="small">确定</el-button>
      </span>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import upload from "@/components/uploadImg/upload";

import { thirdpartyList,thirdpartyAdd ,thirdpartyDel  } from "@/api/thirdparty"
export default {
  name:'other-manage',
  components:{
    upload
  },
  data() {
    return {
      activeName:3,
      listQuery: {
        page: 1,
        limit: 20,
        cnName:'',
        sys:3
      },
      total: 0,
      list:[],
      loading:false,  //表格加载
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      temp: {
        cnName: '',
        userName: '',
        password: '',
        orgName: '',
        sys: this.activeName,
      },
      rules: {
        cnName: [{ required: true, message: '请输入昵称', trigger: 'change' }],
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        orgName: [{ required: true, message: '请输入学校名称', trigger: 'blur' }]
      },
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(290)
    this.getList()
  },
  methods:{
    getList(){
      this.loading = true
      thirdpartyList(this.listQuery).then(res=>{
        this.loading = false
        if(res.data.msg == "success"){
          this.list = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.list = []
        }
      })
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    resetTemp() {
      this.temp = {
        cnName: '',
        userName: '',
        password: '',
        orgName: '',
        sys: this.activeName,
      }
    },
    handleClick(tab){
      if(tab.props.name == 3) {
        // 简易版
        this.listQuery.sys = 3
        this.getList()
      }else if(tab.props.name == 2) {
        // 税局
        this.listQuery.sys = 2
        this.getList()
      }else if(tab.props.name == 1) {
        // 个税
        this.listQuery.sys = 1
        this.getList()
      }
    },
    // 新增
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          thirdpartyAdd(this.temp).then(res => {
            if(res.data.msg == 'success'){
              this.getList()
              this.dialogFormVisible = false
              this.$qzfMessage("创建成功")
            } 
          })
        }
      })
    },
    //编辑 
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          thirdpartyAdd(this.temp).then(res => {
            if(res.data.msg == 'success'){
              this.getList()
              this.dialogFormVisible = false
              this.$qzfMessage("更新成功")
            }
          })
        }
      })
    },
    handleDelete(row){
      this.$confirm('你确定要删除该账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        thirdpartyDel(row).then(res=>{
          if(res.data.msg == 'success'){
            this.getList()
            this.$qzfMessage("删除成功")
          }
        })
      });
    },
    
    // //删除
    // handledel(row) {
    //   this.$confirm('你确定要删除该集团账号吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     delGroup({id:row.groupId}).then(res=>{
    //       if(res.data.msg == 'success'){
    //         this.getList()
    //         this.$qzfMessage("删除成功")
    //       }
    //     })
    //   });
    // },
    // imgUrl(val) {
    //   this.temp.logoUrl = val
    // },
  }
}
</script>

<style scoped lang="scss">
.top_btns {
  margin-bottom: 10px;
  .left_search{
    float: left;
    width: 70%;
  }
  .right_btns {
    float: right;
    width: 30%;
    text-align: right;
  }
}
.el-input {
  width: 96%;
}
.item-p{
  border-top: 1px solid #efefef;
}
.item-p:nth-child(1){
  border-top: none;
}
</style>